import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination, Spinner } from '@/components/ui'
import { formatDate } from '@/utils/formatters'
import { useBienContext } from '@/features/biens/BienContext'
import { fetchActivities } from '@/features/activities/activitiesSlice'

export default () => {
  const dispatch = useDispatch()
  const { bien } = useBienContext()
  const activities = useSelector(state => state.activities.items)
  const pagination = useSelector((state) => state.activities.pagination)
  const loading = useSelector(state => state.activities.loadingStatus.fetchList)

  useEffect(
    () => {
      if(activities.length == 0 && bien?.id) {
        dispatch(fetchActivities({bien_id: bien.id}))
      }
    },
    [bien?.id]
  )
  
  const handlePageChange = (page) => {
    // Mettre à jour les filtres avec la nouvelle page
    dispatch(fetchActivities({bien_id: bien.id, page}))
  }

  return (
    <div className='mb-4'>
      <h3 className="text-md font-semibold mb-2">
        Historique des activités de ce logement
      </h3>
      <div className="bg-primary-100 p-4 rounded-none w-full h-full"> 
        { loading && <Spinner color="primary" /> }
        { !loading && (
          <>
            <div className="overflow-x-auto">
              <table className="table table-zebra w-full">
                <thead>
                  <tr>
                    <th>Date d'activité</th>
                    <th>Détails</th>
                  </tr>
                </thead>
                <tbody>
                  { activities?.length == 0 ? (
                    <tr>
                      <td colSpan="2" className="text-center py-4 text-gray-600 italic">
                        Aucune activité
                      </td>
                    </tr>
                  ) : (
                    activities.map((activity, index) =>(
                      <tr key={index}>
                        <td className="w-[150px]">
                          {formatDate(activity.date_activity || '')}
                        </td>
                        <td>
                          <pre className="text-balance">{activity.details}</pre> 
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            { pagination.totalPages > 1 && (
              <Pagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}